import axios from 'axios'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'


let defaultState = {
  // PUBLICATIONS
  publications: [],
  fetchingPublications: false,
  fetchingPublicationMetadata: false,
  totalPublicationCount: 0,
  filteredPublicationCount: 0,
  publicationsPerPage: 0,
  currentPublicationsPage: 1,
  metadata: {},
  publicationsCancelToken: null,

  // PUBLICATION MANAGEMENT
  publicationManagementMode: false,
  publicationsApprovalStatusFilter: [],
  publicationsApprovalStatusSortType: '',

  // PUBLICATION FIELDS DATA
  therapeuticAreas: [],
  studyDesigns: [],
  dataSources: [],
  dataSourceTypes: [],
  methodAnalysisTypes: [],
  publicationTypes: [],
  fetchingPublicationFieldsData: false,

  // FILTERS
  publicationsSearchTerm: '',
  publicationsYearFilter: [],
  publicationsAuthorFilter: [],
  publicationsSortType: '',
  publicationsClientFilter: [],
  publicationsProductFilter: [],
  publicationsIndicationFilter: [],
  publicationsTherapeuticAreasFilter: [],
  publicationsStudyDesignsFilter: [],
  publicationsDataSourcesFilter: [],
  publicationsDataSourceTypesFilter: [],
  publicationsMethodAnalysisTypesFilter: [],
  publicationsPublicationTypeFilter: [],
  publicationsDoneWithGenesis: ["Yes", "No"],
  publicationsRegulatoryRelated: ["Yes", "No"],
  // publicationsTherapeuticAreaFilter: [],
  // publicationsAnalysisTypeFilter: [],
  // publicationsDatabaseFilter: [],
}

export default function managePublications(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_PUBLICATIONS":
      return { ...state, fetchingPublications: true }
    case "SET_PUBLICATIONS":
      return {
        ...state,
        fetchingPublications: false,
        publications: action.payload.results,
        totalPublicationCount: action.payload.total_count,
        filteredPublicationCount: action.payload.filtered_count,
        publicationsPerPage: action.payload.results_per_page,
       }
    case "ERROR_FETCHING_PUBLICATIONS":
      return {
        ...state,
        fetchingPublications: false,
        publications: [],
        totalPublicationCount: 0,
        filteredPublicationCount: 0,
        publicationsPerPage: 0,
       }
    case "CHANGE_PUBLICATIONS_PAGE":
      return { ...state, currentPublicationsPage: action.payload }
    case "FETCHING_PUBLICATION_METADATA":
      return { ...state, fetchingPublicationMetadata: action.payload }
    case "SET_PUBLICATION_METADATA":
      return { ...state, metadata: action.payload, fetchingPublicationMetadata: false }
    case "CHANGE_PUBLICATIONS_FILTER":
      return { ...state, [action.payload.key]: action.payload.value }
    case "CLEAR_ALL_PUBLICATIONS_FILTERS":
      return {
        ...state,
        publicationsSearchTerm: '',
        publicationsYearFilter: [],
        publicationsAuthorFilter: [],
        publicationsSortType: '',
        publicationsClientFilter: [],
        publicationsProductFilter: [],
        publicationsIndicationFilter: [],
        publicationsTherapeuticAreasFilter: [],
        publicationsStudyDesignsFilter: [],
        publicationsDataSourcesFilter: [],
        publicationsDataSourceTypesFilter: [],
        publicationsMethodAnalysisTypesFilter: [],
        publicationsPublicationTypeFilter: [],
        publicationsDoneWithGenesis: ["Yes", "No"],
        publicationsRegulatoryRelated: ["Yes", "No"],
        publicationsApprovalStatusFilter: [],
        // publicationsTherapeuticAreaFilter: [],
        // publicationsAnalysisTypeFilter: [],
        // publicationsDatabaseFilter: [],
       }
    case "UPDATE_PUBLICATION":
      const updatedPublicationIndex = state.publications.findIndex(pub => pub.id === action.payload.id)

      const publications = [
        ...state.publications.slice(0, updatedPublicationIndex),
        action.payload,
        ...state.publications.slice(updatedPublicationIndex + 1),
      ]
      return { ...state, publications }
    case "ADD_PUBLICATION":
      return { ...state, publications: [...state.publications, action.payload] }
    case "REMOVE_PUBLICATION":
      const filteredPublications = state.publications.filter(pub => pub.id !== action.payload)
      return { ...state, publications: filteredPublications }
    case "RESET_PUBLICATION_STATE":
      return defaultState
    case "FETCHING_PUBLICATION_FIELDS_DATA":
      return { ...state, fetchingPublicationFieldsData: true }
    case "SET_PUBLICATION_FIELDS_DATA":
      return {
        ...state,
        ...action.payload,
        fetchingPublicationFieldsData: false,
      }
      // for (const key in action.payload) {
      //   updatedState[key] = action.payload[key]
      // }
      // return updatedState
    case "SET_PUBLICATIONS_CANCEL_TOKEN":
      return { ...state, publicationsCancelToken: action.payload }
    case "TOGGLE_MANAGEMENT_MODE":
        return { ...state, publicationManagementMode: !state.publicationManagementMode }
    case "CHANGE_PUBLICATION_APPROVAL_SORT":
        return { ...state, publicationsApprovalStatusSortType: action.payload }
      case "CLEAR_ALL_PUBLICATION_APPROVAL_FILTERS":
        return {
          ...state,
          publicationsApprovalStatusFilter: [],
          publicationsApprovalStatusSortType: "",
        }
    default:
      return state
  }
}


const fetchingPublications = () => {
  return { type: "FETCHING_PUBLICATIONS" }
}

const setPublications = (publications) => {
  return { type: "SET_PUBLICATIONS", payload: publications }
}

const errorFetchingPublications = () => {
  return { type: "ERROR_FETCHING_PUBLICATIONS" }
}

export const changePublicationsPage = (page) => {
  return { type: "CHANGE_PUBLICATIONS_PAGE", payload: page }
}

export const changePublicationsFilter = (key, value) => {
  return { type: "CHANGE_PUBLICATIONS_FILTER", payload: { key, value } }
}

export const clearAllPublicationFilters = () => {
  return { type: "CLEAR_ALL_PUBLICATIONS_FILTERS" }
}

export const updatePublication = (publication) => {
  return { type: "UPDATE_PUBLICATION", payload: publication }
}

export const addPublication = (publication) => {
  return { type: "ADD_PUBLICATION", payload: publication }
}

export const removePublication = (publicationId) => {
  return { type: "REMOVE_PUBLICATION", payload: publicationId }
}

export const fetchingPublicationFieldsData = () => {
  return { type: "FETCHING_PUBLICATION_FIELDS_DATA" }
}

export const changePublicationApprovalStatusSortType = (approval_sort_type) => {
  return { type: "CHANGE_PUBLICATION_APPROVAL_SORT", payload: approval_sort_type }
}

export const clearAllPublicationApprovalFilters = () => {
  return { type: "CLEAR_ALL_PUBLICATION_APPROVAL_FILTERS" }
}

export const getPublicationsWithFilters = (page = 1, props) => {
  return (dispatch) => {
    const { filters, sort_by, approval_sort_by } = createFilters(props)
    dispatch(getPublications(page, filters, sort_by, approval_sort_by))
  }
}


export const createFilters = (props) => {
  let filters,
      authors,
      citation,
      year,
      therapeutic_areas,
      study_designs,
      data_sources,
      data_source_types,
      method_analysis_types,
      type,
      journal_conference,
      search_term,
      sort_by,
      client,
      product,
      indication,
      publication_types,
      done_with_genesis,
      regulatory_related,
      approval_sort_by,
      approval_status
      // therapeutic_area,
      // analysis_type,
      // database,

  if (props.publicationsAuthorFilter.length) {
    authors = props.publicationsAuthorFilter.map(author => author.id)
  }

  if (props.publicationsSearchTerm) {
    search_term = props.publicationsSearchTerm
  }

  if (props.publicationsYearFilter) {
    year = props.publicationsYearFilter
  }

  
  if (props.publicationsTherapeuticAreasFilter && props.publicationsTherapeuticAreasFilter.length) {
    therapeutic_areas = props.publicationsTherapeuticAreasFilter.map(therapeuticArea => therapeuticArea.id)
  }
  
  if (props.publicationsStudyDesignsFilter && props.publicationsStudyDesignsFilter.length) {
    study_designs = props.publicationsStudyDesignsFilter.map(studyDesign => studyDesign.id)
  }

  if (props.publicationsDataSourcesFilter && props.publicationsDataSourcesFilter.length) {
    data_sources = props.publicationsDataSourcesFilter.map(dataSource => dataSource.id)
  }
  
  if (props.publicationsDataSourceTypesFilter && props.publicationsDataSourceTypesFilter.length) {
    data_source_types = props.publicationsDataSourceTypesFilter.map(dataSourceType => dataSourceType.id)
  }
  
  if (props.publicationsMethodAnalysisTypesFilter && props.publicationsMethodAnalysisTypesFilter.length) {
    method_analysis_types = props.publicationsMethodAnalysisTypesFilter.map(dataSourceType => dataSourceType.id)
  }
  
  if (props.publicationsTypeFilter) {
    type = props.publicationsTypeFilter
  }
  
  if (props.publicationsJournalConferenceFilter) {
    journal_conference = props.publicationsJournalConferenceFilter
  }
  
  if (props.publicationsClientFilter) {
    client = props.publicationsClientFilter
  }

  if (props.publicationsProductFilter) {
    product = props.publicationsProductFilter
  }
  
  if (props.publicationsIndicationFilter) {
    indication = props.publicationsIndicationFilter
  }
  
  if (props.publicationsPublicationTypeFilter) {
    publication_types = props.publicationsPublicationTypeFilter.map(publicationType => publicationType.id)
  }

  
  if (props.publicationsDoneWithGenesis) {
    done_with_genesis = props.publicationsDoneWithGenesis
  }
  
  if (props.publicationsRegulatoryRelated) {
    regulatory_related = props.publicationsRegulatoryRelated
  }

  if (props.publicationsApprovalStatusFilter && props.publicationsApprovalStatusFilter.length) {
    approval_status = props.publicationsApprovalStatusFilter
  }
  
  // if (props.publicationsTherapeuticAreaFilter) {
  //   therapeutic_area = props.publicationsTherapeuticAreaFilter
  // }

  // if (props.publicationsAnalysisTypeFilter) {
  //   analysis_type = props.publicationsAnalysisTypeFilter
  // }
  
  // if (props.publicationsDatabaseFilter) {
  //   database = props.publicationsDatabaseFilter
  // }
  
  if (authors || citation || year || 
      therapeutic_areas || study_designs || data_sources || client ||
      data_source_types || method_analysis_types || type || journal_conference || 
      search_term || product || indication ||
      publication_types || done_with_genesis || regulatory_related || approval_status) 
  {
    filters = {
      authors,
      citation,
      year,
      therapeutic_areas,
      study_designs,
      data_sources,
      data_source_types,
      method_analysis_types,
      type,
      journal_conference,
      search_term,
      client,
      product,
      indication,
      publication_types,
      done_with_genesis,
      regulatory_related,
      approval_status
      // therapeutic_area,
      // analysis_type,
      // database,
    }
  }

  if (props.publicationsSortType) {
    sort_by = props.publicationsSortType
  }

  if (props.publicationsApprovalStatusSortType) {
    approval_sort_by = props.publicationsApprovalStatusSortType
  }

  return { filters, sort_by, approval_sort_by }
}

export const getPublications = (page = 1, filters = null, sort_by = null, approval_sort_by = null) => {
  return (dispatch, getState) => {
    const { publicationsCancelToken } = getState().managePublications
    if (publicationsCancelToken && publicationsCancelToken.cancel) {
      publicationsCancelToken.cancel("The request was cancelled.")
    }
    const cancelToken = axios.CancelToken.source()
    dispatch({ type: "SET_PUBLICATIONS_CANCEL_TOKEN", payload: cancelToken })

    dispatch(fetchingPublications())
    axios(`${getServerURL()}publications/?page=${page}`,
      { headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      params: {
        list_view: true,
        filters,
        sort_by,
        approval_sort_by,
      },
      cancelToken: cancelToken.token
    })
    .then(response => {
      dispatch(setPublications(response.data))
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        return
      }
      const message = "There was an error fetching the publications"
      handleErrorFetchingData(error, message)
      dispatch(errorFetchingPublications())
    })
  }
}

export const getPublicationMetadata = () => {
  return dispatch => {
    dispatch({ type: "FETCHING_PUBLICATION_METADATA", payload: true })
    axios.get(`${getServerURL()}publications/metadata/`, {
      headers: {
        "Authorization": `Bearer ${ localStorage.getItem("token") }`
      }
    })
    .then(response => {
      dispatch({ type: "SET_PUBLICATION_METADATA", payload: response.data })
    })
    .catch(error => {
      const message = "There was an error fetching publication metadata"
      handleErrorFetchingData(error, message)
      return dispatch(errorFetchingPublications())
    })
  }
}

export const getPublicationFieldsData = () => {
  return dispatch => {
    const TherapeuticAreasRequest = axios.get(`${getServerURL()}therapeutic-areas/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    const StudyDesignsRequest = axios.get(`${getServerURL()}study-designs/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    const DataSourcesRequest = axios.get(`${getServerURL()}data-sources/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    const DataSourceTypesRequest = axios.get(`${getServerURL()}data-source-types/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    const MethodAnalysisTypesRequest = axios.get(`${getServerURL()}method-analysis-types/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    const PublicationTypesRequest = axios.get(`${getServerURL()}publication-types/`,
      {headers: { "Authorization": `Bearer ${localStorage.getItem("token")}`}
    })
    
    axios.all([TherapeuticAreasRequest, StudyDesignsRequest, DataSourcesRequest, DataSourceTypesRequest, MethodAnalysisTypesRequest, PublicationTypesRequest])
    .then(axios.spread((therapeuticAreas, studyDesigns, dataSources, dataSourceTypes, methodAnalysisTypes, publicationTypes) => {
      let publicationFieldsData = {
        therapeuticAreas: therapeuticAreas.data,
        studyDesigns: studyDesigns.data,
        dataSources: dataSources.data,
        dataSourceTypes: dataSourceTypes.data,
        methodAnalysisTypes: methodAnalysisTypes.data,
        publicationTypes: publicationTypes.data,
      }
    
      dispatch({ type: "SET_PUBLICATION_FIELDS_DATA", payload: publicationFieldsData})
    })).catch(error => {
      const message = "There was an error in getting Publication Fields Data..."
      handleErrorFetchingData(error, message)
    })
  }
}

export const togglePublicationManagementMode = () => {
  return { type: "TOGGLE_MANAGEMENT_MODE" }
}



// WEBPACK FOOTER //
// ./src/routes/publications/reducers/managePublications.js